import React from 'react';
import { CornerDownLeft } from 'lucide-react';

/**
 * The one quiet line above the composer that gets the previous conversation
 * back. A real button, not a decorated span: it has to be tabbable and
 * operable from the keyboard like every other way into the thread.
 */
export interface RobbieContinueLineProps {
  /** How many earlier messages are folded away. */
  count: number;
  /** Already-formatted "2 hours ago" / "yesterday". */
  relativeTime: string;
  onSelect: () => void;
  className?: string;
}

export const RobbieContinueLine: React.FC<RobbieContinueLineProps> = ({
  count,
  relativeTime,
  onSelect,
  className = '',
}) => {
  const label = `Continue your last conversation from ${relativeTime} (${count} ${count === 1 ? 'message' : 'messages'})`;
  return (
    <button
      type="button"
      onClick={onSelect}
      aria-label={label}
      className={`flex w-full items-center gap-s2 rounded-control px-s2 py-[5px] text-left text-[11px]
        font-medium text-ink-muted transition-colors duration-100 hover:text-action focus:outline-none
        focus-visible:ring-2 focus-visible:ring-action focus-visible:ring-offset-1 ${className}`}
    >
      <CornerDownLeft className="h-[12px] w-[12px] shrink-0" />
      <span className="min-w-0 leading-[1.4]">{label}</span>
    </button>
  );
};

export default RobbieContinueLine;
